import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  UPDATE_GROUP_STATUS: {
    url: "gebruiker/group/update",
    method: "post",
  },

  UPDATE_GYM_STATUS: {
    url: "gebruiker/update-details",
    method: "post",
  },

  GET_FUNCTIES: {
    url: "gebruiker/functies",
    method: "post",
  },
 
};
export const useUpdateGroupStatus = () =>
  useApiFetcherSWR(API_ENDPOINT.UPDATE_GROUP_STATUS);

export const useUpdateGymStatus = () =>
  useApiFetcherSWR(API_ENDPOINT.UPDATE_GYM_STATUS);


export const useFunctiesData = (params = {}, enabled = true) =>
  useApiFetcherSWR(
    enabled
      ? {
          ...API_ENDPOINT.GET_FUNCTIES,
          params,
        }
      : null
  );